// getPackageFromOfferForOrderItem finds and returns the package, given an order item
import getPackageFromOffer from './getPackageFromOffer'

export default function getPackageFromOfferForOrderItem(
  offer: App.Offer,
  orderItem: App.OrderItem,
) {
  return getPackageFromOffer(offer, orderItem.package.id, orderItem.duration)
}
